export const FETCH_CREATE_TEMPLATE_REQUEST = 'FETCH_CREATE_TEMPLATE_REQUEST'
export const FETCH_CREATE_TEMPLATE_SUCCESS = 'FETCH_CREATE_TEMPLATE_SUCCESS'
export const FETCH_CREATE_TEMPLATE_FALUIRE = 'FETCH_CREATE_TEMPLATE_FALUIRE'
